// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"273":"85d5997a5557de16","537":"e323c23b6b4f32f7","557":"6e6059b44bdf1dc4"}[chunkId] + ".js";
};